module.exports = __webpack_public_path__ + "static/media/testimage123321.d6832489.jpg";